// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import endpoints from './endpoints';

export const baseUrl = 'https://test-adacor-portal.de.toyota-fs.com/portalws';
export const gaTagMangerProperty = 'GTM-N2T9JDH';
export const googleSiteVerification = 'vLNN-AoYPuGZ_PQDRgdjPf_nZoz6EIubwVjtBIW9lDc';

export const environment = {
  production: false,
  testPersonId: 78815,
  sessionTimeoutMinutes: 15,
  predefinedLoginEmail: null,
  predefinedLoginPassword: null,
  endpoints: endpoints(baseUrl),
  momentDateFormat: {
    parseInput: 'DD.MM.YYYY LT',
    fullPickerInput: 'DD.MM.YYYY LT',
    datePickerInput: 'DD.MM.YYYY',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
  earlyTerminationReasons: [
    {
      text: 'Ich möchte einen neuen Toyota finanzieren',
      showOutboundTeamMessage: false,
    },
    {
      text: 'Ich habe finanzielle Mittel zur Verfügung um abzulösen',
      showOutboundTeamMessage: false,
    },
    {
      text: 'Ich möchte ein anderes Fahrzeug finanzieren',
      showOutboundTeamMessage: true,
    },
    {
      text: 'Ich möchte mehrere Kreditverträge zusammenlegen',
      showOutboundTeamMessage: true,
    },
  ],
  vehicleLetterShipmentReasons: [
    {
      text: 'Ausstellung eines neuen Fahrzeugscheins',
      action: '',
      zdReason: 1791,
    },
    {
      text: 'Halteränderung',
      action: 'inputNewOwner',
      zdReason: 13600,
    },
    {
      text: 'Standortverlegung',
      action: 'checkForAddressChange',
      zdReason: 1794,
    },
    {
      text: 'Kennzeichentausch',
      action: '',
      zdReason: 1793,
    },
    {
      text: 'Technische Änderung',
      action: '',
      zdReason: 1798,
    },
    {
      text: 'Nicht vorhandener Versandgrund',
      action: '',
      zdReason: 0,
    },
  ],
  casesOfInsurance: [
    {
      text: 'Haftpflicht',
      zdCase: 4322,
    },
    {
      text: 'Vollkasko',
      zdCase: 4321,
    },
    {
      text: 'Totalschaden',
      zdCase: null,
    },
  ],
  changeBankDetails: {
    maximumDaysInTheFuture: 30 * 6, // 6 months
    validFromWarningDays: 5,
  },
  feature: {
    defermentofpayment: true,
    paymentdatechange: true,
    specialrepayment: true,
    rsvlrvapplication: true,
    rsvlrvplusapplication: true,
    onlinedeal: true,
  },
  i18nLocation: './assets/lang/',
};
